export default "__VITE_ASSET__BAUD9ybY__"